import { firestore, auth } from '../firebase';
import { collection, getDocs, doc, deleteDoc } from 'firebase/firestore';
import { deleteUser } from 'firebase/auth';

const subCollections = ['exercises', 'workouts', 'routines', 'workout_entries', 'routine_entries', 'exercise_sets'];

export const deleteUserData = async (userId: string) => {
    try {
        // Loop through all sub-collections
        for (const subCollection of subCollections) {
            const subColRef = collection(firestore, `users/${userId}/${subCollection}`);
            const subColDocs = await getDocs(subColRef);

            // Delete all documents in the sub-collection using Promise.all
            const deletePromises = subColDocs.docs.map((docSnapshot) => {
                const docRef = doc(firestore, `users/${userId}/${subCollection}/${docSnapshot.id}`);
                return deleteDoc(docRef);
            });

            await Promise.all(deletePromises); // Ensure all docs are deleted before moving on
        }

        // Finally, delete the user from Firebase Authentication
        const currentUser = auth.currentUser;
        if (currentUser) {
            await deleteUser(currentUser);
        }

        alert('User account and data deleted successfully.');
    } catch (error) {
        console.error('Error deleting user data:', error);
        alert('Failed to delete user data. Please try again.');
    }
};
